<template>
  <v-container class="none-fluid">
    <banner>PhD Timeline</banner>
    <div>
      <iframe src="https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=v2%3A2PACX-1vRhZHf2Tx0vGKHw0E5vyRKBYB5LDRIe4WboTwJG-i-bMp5NPaNhg1mvCPeJpWDUGmlz5DjRyYX4iS9M&font=Default&lang=en&initial_zoom=2&marker_width_min=20&width=100%25&height=750" width="100%" height="750" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0"></iframe>
    </div>
  </v-container>
</template>

<script>
import Banner from "../global/Banner";

export default {
  components: {
    Banner,
  },
};
</script>
